import { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from '../../../types/default-cloud-graph-customer-org-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from '../../../types/default-cloud-graph-deal-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { ForgePioHubspotIcon, ForgePioHubspotSearchResultIcon } from './icon';

export const forgePioHubspotConfig: ThirdPartyConfig = {
	displayName: 'HubSpot by Pio',
	id: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
	resourceType: ProductResourceTypes3P.ForgePioHubspotDev,
	icon: get3PLogo(ForgePioHubspotIcon, 'ForgePioHubspot', 'medium'),
	searchResultIcon: get3PLogo(ForgePioHubspotSearchResultIcon, 'ForgePioHubspot', 'large'),
	integrationAri: 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.CustomerOrg,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.CustomerOrg],
			},
		],
		[
			TypeFilterValueKey.Deal,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Deal],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
